/**
 * モーダルプラグイン modaalの設定
 * https://github.com/humaan/Modaal
 */

$(document).ready(function () {
	// 動画用スクリプト
	$('.modal_video').modaal({
		type: 'video'
	});

	$('.modal_video-mp4').on('click', function (e) {
		e.preventDefault();
		var target = $(this).data('target');
		var $videoEl = $(target).find('video');
		var video = $videoEl[0];

		// モーダルを開く直前にsrcをセット（初回のみ）
		if (!$videoEl.data('loaded')) {
			var base = $videoEl.data('base'); // data属性からベースURLを取得
			var suffix = window.innerWidth <= 1024 ? '--sp' : '';

			$videoEl.find('source').each(function () {
				var ext = $(this).attr('data-ext');
				var type = $(this).attr('type');
				$(this).attr('src', base + suffix + '.' + ext);
			});

			video.load();
			$videoEl.data('loaded', true);
		}

		if (!$(this).data('modaal-initialised')) {
			$(this).modaal({
				type: 'inline',
				content_source: target,
				after_open: function () {
					video.play();
				},
				after_close: function () {
					video.pause();
				}
			});
		}

		$(this).modaal('open');
	});

	//特定の要素を閉じるボタンに設定
	$('.piyopiyo').modaal('close');


	$('.modaal-gallery').modaal({
		type: 'image'
	});

});
